/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import * as types from '../constants/ActionTypes';

const getInitialState = () => ({
  data: [],
  owner: {
    name: null,
    email: null,
  },
  fetchingData: false,
  fetchDataError: null,
});

const initialState = getInitialState();

const parseTenantMembers = data => {
  if (!isEmpty(data)) {
    const tenantType = Object.keys(data.docs[0].services);

    return {
      name: data.docs[0].contactName,
      email: data.docs[0].contactEmail,
      members: data.docs[0].services[tenantType].members,
    };
  }
  return {};
};

export const getTenantMembers = state => get(state, 'users.data');
export const getTenantOwner = state => get(state, 'users.owner');
export const getTenantMembersIsLoading = state => get(state, 'users.fetchingData');
export const getTenantMembersError = state => get(state, 'users.fetchDataError');

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_TENANT_MEMBERS_REQUEST:
      return { ...state, fetchingData: true, fetchDataError: null };

    case types.LOAD_TENANT_MEMBERS_SUCCESS: {
      const parsedData = parseTenantMembers(action.data);

      return {
        ...state,
        data: parsedData.members,
        owner: {
          name: parsedData.name,
          email: parsedData.email,
        },
        fetchingData: false,
        fetchDataError: null,
      };
    }
    case types.LOAD_TENANT_MEMBERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchingData: false,
        fetchDataError: action.error,
      };

    default:
      return state;
  }
};
